function initialState() {
  return {
    messages: [],
    tourRecord: null,
    prospect: null,
    redirectUrl: `//${window.location.host}`,
    audioStreamInitialState: true,
    videoStreamInitialState: true
  };
}

const getters = {
  messages: (state) => state.messages,
  tourRecord: (state) => state.tourRecord,
  prospect: (state) => state.prospect,
  redirectUrl: (state) => state.redirectUrl,
  audioStreamInitialState: (state) => state.audioStreamInitialState,
  videoStreamInitialState: (state) => state.videoStreamInitialState
};

const mutations = {
  ADD_CHAT_MESSAGE(state, payload) {
    state.messages.push(payload);
  },
  SET_TOUR_RECORD(state, payload) {
    state.tourRecord = payload;
  },
  SET_PROSPECT(state, payload) {
    state.prospect = payload;
  },
  SET_REDIRECT_URL(state, payload) {
    state.redirectUrl = payload;
  },
  SET_AUDIO_STREAM_INITIAL_STATE(state, payload) {
    state.audioStreamInitialState = payload;
  },
  SET_VIDEO_STREAM_INITIAL_STATE(state, payload) {
    state.videoStreamInitialState = payload;
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations
};
